import { Outlet } from 'react-router-dom';
import { AppShellBrand } from '@shared/components/AppShellBrand';

export function MainLayout() {
  return (
    <div className="app-shell">
      <header className="app-shell__header">
        <AppShellBrand>AG.platform</AppShellBrand>
      </header>
      <main className="app-shell__main">
        <Outlet />
      </main>
    </div>
  );
}
